import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const content = {
  privacidade: ["Política de Privacidade", "Esta página será atualizada com a política de privacidade e informação RGPD da Problema360 antes da publicação final."],
  termos: ["Termos e Condições", "Esta página será atualizada com os termos e condições de prestação de serviços, marcações e orçamentos após validação da empresa."],
  cookies: ["Política de Cookies", "Esta página será atualizada com a política de cookies e as opções de consentimento aplicáveis ao website."],
};

export default function LegalPage() {
  const { type } = useParams();
  const [title, text] = content[type] || ["Informação legal", "O conteúdo desta página está a ser preparado."];
  return <main className="page-main"><section className="legal-page container"><Link to="/" className="back-link" data-testid="legal-back-link"><ArrowLeft size={15} /> Voltar ao início</Link><span className="eyebrow">Problema360 · informação</span><h1>{title}</h1><p>{text}</p></section></main>;
}
